import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./screen-reader-only.css.ts.vanilla.css-mistica.js";
var f = "gwdgwo1 _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfhf _1y2v1nfkl _1y2v1nfk2";
export { f as screenReaderOnly };
